import { Reveal } from "./Reveal";

const CHAPTERS = [
  { num: "I", title: "A Dicotomia do Controle", desc: "O princípio fundamental: separe o que depende de você do que não depende — e liberte-se de 90% das suas preocupações." },
  { num: "II", title: "Memento Mori", desc: "A lembrança da morte como ferramenta de urgência: pare de adiar a vida que você quer viver." },
  { num: "III", title: "Amor Fati", desc: "Amar o destino: como transformar perdas, fracassos e rejeições em combustível para crescer." },
  { num: "IV", title: "Premeditatio Malorum", desc: "A visualização negativa dos antigos: ensaie o pior cenário e perca o medo de enfrentá-lo." },
  { num: "V", title: "O Desprendimento", desc: "Liberte-se da opinião alheia e da necessidade de aprovação que sabota suas decisões." },
  { num: "VI", title: "Disciplina Inegociável", desc: "Construa hábitos à prova de motivação: a vontade treinada como um músculo, dia após dia." },
  { num: "VII", title: "Domínio da Raiva", desc: "As técnicas de Sêneca para responder — e não reagir — ao estresse, à crítica e ao conflito." },
  { num: "VIII", title: "O Diário Estoico", desc: "O ritual de reflexão de Marco Aurélio adaptado: 10 minutos por dia para uma mente clara." },
];

export const Chapters = () => (
  <section data-testid="manifesto-chapters-section" className="py-20 md:py-28 bg-[#0f0f13] border-y border-[#d4af37]/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">O manifesto · 8 capítulos</p>
        <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea] leading-snug">
          O que você vai <span className="text-gold-gradient italic">aprender</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-zinc-400 leading-relaxed">
          Nada de teoria distante. Cada capítulo termina com exercícios práticos para aplicar na
          sua rotina — no trabalho, nos relacionamentos e nas decisões difíceis.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {CHAPTERS.map((ch, i) => (
          <Reveal key={ch.num} delay={0.06 * i}>
            <div
              data-testid={`chapter-card-${i + 1}`}
              className="group h-full rounded-xl border border-white/[0.06] bg-[#14141a] p-7 transition-colors duration-500 hover:border-[#d4af37]/40 hover:bg-[#1a1a21]"
            >
              <span className="font-serif text-4xl text-[#d4af37]/50 transition-colors duration-500 group-hover:text-[#f5d77f]">
                {ch.num}
              </span>
              <h3 className="mt-5 font-sans text-base sm:text-lg font-bold text-[#f4f1ea]">{ch.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{ch.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
